import { createContext } from 'react';

const FoldersContext = createContext();

export default FoldersContext;